import React, { useState } from 'react';
import {
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableContainer,
    Autocomplete,
    Switch,
    FormControlLabel,
    IconButton,
    InputAdornment,
    Typography
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import VendorChildHead from './vendorChildHead';
import EditTextField from '../../../overrides/editField';
import { useSelector } from 'react-redux';

const TABLE_HEAD = [
    { id: 'landLineNumber ', label: 'Landline Number ', alignRight: false },
    { id: 'mobileNumber', label: 'Mobile Number', alignRight: false },
    { id: 'emailID', label: 'Email ID', alignRight: false },
    { id: 'divisionId', label: 'Division', alignRight: false },
    { id: 'status', label: 'Payment Status' },
    { id: 'gateway', label: 'Payment Gateway' },
    { id: 'key', label: 'Payment Key' },
    { id: 'secret', label: 'Payment Secret' },
];

const VendorChildTable = ({
    status,
    editData,
    setEditData,
    handleEditChange,
    formErrors,
    emailValid,
    phoneValid,
    expandOpen, rowData, clearFormError
}) => {

    const { EmployeeReducers: { divisionList }, VendorReducers: { getPaymentGateway } } =
        useSelector(state => state);

    const [showSecret, setShowSecret] = useState(false);
    // const [page, setPage] = useState(0);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    // const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const isPaymentEnabled =
        rowData.gateway_allowed === 1 ||
        rowData.gateway_allowed === true;


    const selectedGateway =
        getPaymentGateway?.find(
            g => Number(g.gateway_id) === Number(rowData.gateway_id)
        ) || null;


    return (


        <>
            {expandOpen &&
                <TableContainer sx={{ overflow: 'unset' }}>
                      <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
                        <VendorChildHead
                            order={order}
                            orderBy={orderBy}
                            headLabel={TABLE_HEAD}
                            //   rowCount={USERLIST.length}
                            //   numSelected={selected.length}
                            onRequestSort={handleRequestSort}
                        />
                        <TableBody>
                            <TableRow
                                // hover
                                tabIndex={-1}
                                sx={{ '& > *': { borderBottom: 'unset' } }}
                            >
                                {status === 'list' ?
                                    <>
                                        <TableCell align="left">
                                            <Typography variant='t14_600'>
                                                {rowData.CLANDLINENUMBER}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant='t14_600'>
                                                {rowData.CMOBILENUMBER}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant='t14_600'>
                                                {rowData.CEMAILID}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant='t14_600'>
                                                {rowData.cDivisionName}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant='t14_600'>
                                                {isPaymentEnabled ? 'Enabled' : 'Disabled'}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant="t14_600">
                                                {selectedGateway?.gateway_name}
                                            </Typography>
                                        </TableCell>

                                        <TableCell align="left">
                                            <Typography variant='t14_600'>
                                                {rowData.payment_key}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant='t14_600'>
                                                {rowData.payment_secret ? '••••••' : ''}
                                            </Typography>
                                        </TableCell>
                                    </>
                                    :
                                    <>
                                        <TableCell>
                                            <EditTextField
                                                name="CLANDLINENUMBER"
                                                value={editData.CLANDLINENUMBER || ''}
                                                onChange={handleEditChange}
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <EditTextField
                                                name="CMOBILENUMBER"
                                                value={editData.CMOBILENUMBER || ''}
                                                onChange={handleEditChange}
                                                error={!phoneValid}
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <EditTextField
                                                name="CEMAILID"
                                                value={editData.CEMAILID || ''}
                                                onChange={handleEditChange}
                                                error={!emailValid}
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <Autocomplete
                                                size="small"
                                                options={divisionList}
                                                getOptionLabel={(o) => o.name}
                                                value={
                                                    divisionList.find(d => d.id === editData.nDivisionID) || null
                                                }
                                                onChange={(e, v) =>
                                                    setEditData({ ...editData, nDivisionID: v?.id })
                                                }
                                                renderInput={(p) => <EditTextField {...p} />}
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={!!editData.GATEWAY_ALLOWED}
                                                        onChange={(e) =>
                                                            setEditData({
                                                                ...editData,
                                                                GATEWAY_ALLOWED: e.target.checked,
                                                            })
                                                        }

                                                    />
                                                }
                                                label={editData.GATEWAY_ALLOWED ? 'Enabled' : 'Disabled'}
                                            />
                                        </TableCell>

                                        <TableCell>
                                            {editData.GATEWAY_ALLOWED && (
                                                <Autocomplete
                                                    size="small"
                                                    options={getPaymentGateway || []}
                                                    getOptionLabel={(o) => o.gateway_name}
                                                    value={
                                                        getPaymentGateway.find(
                                                            g => g.gateway_id === editData.GATEWAY_ID
                                                        ) || null
                                                    }
                                                    onChange={(e, v) => {
                                                        setEditData({
                                                            ...editData,
                                                            GATEWAY_ID: v?.gateway_id,
                                                        });

                                                        clearFormError('GATEWAY_ID');
                                                    }}

                                                    renderInput={(p) => (
                                                        <EditTextField
                                                            {...p}
                                                            error={Boolean(formErrors.GATEWAY_ID)}
                                                            helperText={formErrors.GATEWAY_ID}
                                                        />
                                                    )}
                                                />
                                            )}
                                        </TableCell>

                                        <TableCell>
                                            {editData.GATEWAY_ALLOWED && (
                                                <EditTextField
                                                    name="PAYMENT_KEY"
                                                    value={editData.PAYMENT_KEY || ''}
                                                    onChange={handleEditChange}
                                                    error={Boolean(formErrors.PAYMENT_KEY)}
                                                    helperText={formErrors.PAYMENT_KEY}
                                                    autoComplete="off"
                                                />
                                            )}
                                        </TableCell>

                                        <TableCell>
                                            {editData.GATEWAY_ALLOWED && (
                                                <EditTextField
                                                    name="PAYMENT_SECRET"
                                                    type={showSecret ? 'text' : 'password'}
                                                    value={editData.PAYMENT_SECRET || ''}
                                                    onChange={handleEditChange}
                                                    error={Boolean(formErrors.PAYMENT_SECRET)}
                                                    helperText={formErrors.PAYMENT_SECRET}
                                                    autoComplete="new-password"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton onClick={() => setShowSecret(!showSecret)}>
                                                                    {showSecret ? <VisibilityOff /> : <Visibility />}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        </TableCell>
                                    </>
                                }
                            </TableRow>
                        </TableBody>

                    </Table>
                </TableContainer>
            }
        </>




    );
};

export default VendorChildTable;
